/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendChangePasswordDto } from '../../models/backend-change-password-dto';
import { BackendChangePasswordRequestDto } from '../../models/backend-change-password-request-dto';

export interface AccountMeChangePasswordUpdate$XWwwFormUrlencoded$Params {
  body: BackendChangePasswordRequestDto;
}

export function accountMeChangePasswordUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: AccountMeChangePasswordUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendChangePasswordDto>> {
  const rb = new RequestBuilder(rootUrl, accountMeChangePasswordUpdate$XWwwFormUrlencoded.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendChangePasswordDto>;
    }),
  );
}

accountMeChangePasswordUpdate$XWwwFormUrlencoded.PATH = '/api/account/me/change_password/';
